'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Localize = require('../../Localize');

var _Localize2 = _interopRequireDefault(_Localize);

var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');

var _Alert = require('../../ui/Alert');

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Tone-Banner (error). Faehrt seit 2026-06 ueber das zentrale <Alert>-Primitiv.
// Verhaltens-erhaltend: faExclamationTriangle-Icon, KEIN width:100% (fullWidth=false),
// errorColor auf Border/Icon/Content. message faellt auf "request-failed" zurueck.
// `general` (von Modal/Prompt) ist KEINE bekannte Prop -> wird hier bewusst NICHT
// weitergereicht (kein DOM-Crash). Siehe openIssue.
var Error = function Error(_ref) {
  var message = _ref.message,
      details = _ref.details,
      className = _ref.className;
  return _react2.default.createElement(_Alert2.default, {
    className: className,
    tone: _Alert.ALERT_TONES.ERROR,
    icon: _freeSolidSvgIcons.faExclamationTriangle,
    fullWidth: false,
    message: message || _react2.default.createElement(_Localize2.default, { id: 'request-failed' }),
    details: details
  });
};

Error.propTypes = process.env.NODE_ENV !== "production" ? {
  details: _propTypes2.default.node,
  message: _propTypes2.default.node,
  className: _propTypes2.default.string
} : {};

Error.defaultProps = {
  details: null,
  message: null,
  className: undefined
};

exports.default = Error;
module.exports = exports['default'];